import React, { useState, useEffect } from 'react';
import styles from './menuHome.module.scss';
import { TabBar } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import  { ApiCore } from '../../api/index';
import ProjectList from '../projectList/projectList';
import Personal from '../../pagesDoctor/personal/personal';
import utils from '../../utils/utils';
import Menus from './menu.json';
//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3398857_mcvnz8cwfxq.js'
});


const api = new ApiCore();

// const existIcon = {
//     'project': <ProjectList />,
//     'personal': <Personal />
// }

class MenuHome extends React.Component<any, any> {

    constructor(props: any) {
      super(props);
      this.state = {
        selectedTab: 'project',
        hideMenu: true,
        hasNews: false,
        menuArr: []
      };
    }

    componentDidMount() {
        const urlParams = utils.getUrlParams();
        const tab = urlParams && urlParams.tab;
        tab && this.setState({
            selectedTab: tab
        });
        this.getMenus();
    }

    getMenus() {
        // api.getMenus({}, {}).then(res => {
        //     if (res.code + '' === '0') {
        //         const _data = res.data[0].children;
        //         this.setState({
        //             menuArr: _data
        //         })
        //     }
        // });
        const token = sessionStorage.getItem('token');
        if (token) {
            let mToken = JSON.parse(token);
            if (mToken.tenantConfig) {
                this.setState({
                    hideMenu: !mToken.tenantConfig.enableMenu
                })
            }
        }
        const _data = Menus.data[0].children;
        this.setState({
            menuArr: _data
        })
    }

    menusRender() {
        const { menuArr, hasNews } = this.state;
        const existIcon = {
            'project': <ProjectList />,
            'personal': <Personal updateHasNews={(val: any) => { this.updateHasNews(val) }} />
        }
        if (!menuArr || (menuArr && menuArr.length === 0)) {
            return null;
        }
        return (
        <TabBar
            unselectedTintColor="#989898"
            tintColor="#8A7AFB"
            barTintColor="white"
            hidden={this.state.hideMenu}
        >
            {menuArr.map((item: any) => {
                let iconView = item.icon;
                let IconComponent: any = '';
                if (existIcon[item.icon]) {
                    IconComponent = existIcon[item.icon];
                } else {
                    IconComponent = item.icon;
                }
                if(this.state.selectedTab != item.icon) {
                    IconComponent = null;
                }
                return (
                    <TabBar.Item
                        icon={<IconFont type={`icon-${iconView}`} className={`tabbar-icon-${iconView}`}></IconFont>}
                        selectedIcon={<IconFont type={`icon-active-${iconView}`} className={`tabbar-icon-active-${iconView} tabbar-icon-${iconView}`}></IconFont>}
                        title={<div style={{color: this.state.selectedTab == item.icon ? '#4e88f5' : '', fontSize: '13px'}}>{item.name}</div>}
                        key={item.icon}
                        selected={this.state.selectedTab === item.icon}
                        dot={item.icon === 'personal' && hasNews}
                        onPress={() => {
                            this.setState({
                                selectedTab: item.icon
                            },() => {
                                window.history.replaceState({}, item.name, `#/projectList?tab=` + item.icon );
                            });
                            document.title = item.name;
                        }}
                    >
                        {
                            this.state.selectedTab == item.icon ? IconComponent : null
                        }
                    </TabBar.Item>
                )
            })}
        </TabBar>
        )
    }

    updateHasNews(flag: boolean) {
        this.setState({
            hasNews: flag
        });
    }

    render() {
        return (
            <div className={`${styles.homeMenu_content} ${this.state.hideMenu ? styles.hide_menu_btn : ''}`}>
                {
                    this.menusRender()
                }
            </div >
        )
    };
}
export default MenuHome;